import {
    CheckInRecord,
    CheckInRecordApiBody,
    CheckOutRecord,
    CheckOutRecordApiBody,
} from './TrackRecord'
import { isCheckInRecord, isCheckOutRecord } from './TrackRecordHelpers'

export const transformTrackRecordsDomStringToTrackRecords = (domString: string): (CheckInRecord | CheckOutRecord)[] => {
    const trackRecords: (CheckInRecord | CheckOutRecord)[] = JSON.parse(domString)

    if (! Array.isArray(trackRecords)) {
        return []
    }

    return trackRecords.map((trackRecord) => {
        if (isCheckOutRecord(trackRecord)) {
            return {
                ...trackRecord,
                startDate: trackRecord.startDate,
                endDate: trackRecord.endDate,
            }
        }

        return {
            ...trackRecord,
            startDate: trackRecord.startDate,
        }
    })
}

export const transformCheckInTrackRecordToApiCallBody = (record: CheckInRecord): CheckInRecordApiBody => ({
    ...record,
    startDate: record.startDate,
})

export const transformCheckOutTrackRecordToApiCallBody = (record: CheckOutRecord): CheckOutRecordApiBody => ({
    ...record,
    startDate: record.startDate,
    endDate: record.endDate,
})

export const transformTrackRecordsToApiCallBody = (records: (CheckInRecord | CheckOutRecord)[]): (CheckInRecordApiBody | CheckOutRecordApiBody)[] => records.map(record => {
    if (isCheckInRecord(record)) {
        return transformCheckInTrackRecordToApiCallBody(record)
    }

    return transformCheckOutTrackRecordToApiCallBody(record)
})
